import { createTicker } from "../utils/ticker";
import { BehaviorSubject, Subject } from "rxjs";

import createStreams from "./data";

import Object3DManager from "./managers/Object3DManager";

import SceneSystem from "./systems/SceneSystem";
import CameraSystem from "./systems/CameraSystem";
import RenderSystem from "./systems/RenderSystem";
import CanvasSystem from "./systems/CanvasSystem";
import MaterialSystem from "./systems/MaterialSystem";
import AnimationSystem from "./systems/AnimationSystem";
import AnimationToggleSystem from "./systems/AnimationToggleSystem";

import TextureManager from "./managers/TextureManager";
import MaterialManager from "./managers/MaterialManager";
import ModelManager from "./managers/ModelManager";
import EntityManager from "./managers/EntityManager";
import AssetManager from "./managers/AssetManager";
import StateManager from "./managers/StateManager";
import AnimationManager from "./managers/AnimationManager";
import ParentSystem from "./systems/ParentSystem";
import SpriteSystem from "./systems/SpriteSystem";
import TransformSystem from "./systems/TransformSystem";
import InteractionSystem from "./systems/InteractionSystem";
import VisibilitySystem from "./systems/VisibilitySystem";
import PostProcessingSystem from "./systems/PostProcessingSystem";
import MaterialSwitchSystem from "./systems/MaterialSwitchSystem";

// TODO: Can world be function that returs dispose method?

class World {
  queryManager;
  object3DManager;
  materialManager;
  modelManager;
  textureManager;
  entityManager;
  assetManager;

  scene;
  camera;
  cameraControls;
  renderer;
  composer;

  data;
  ticker$;
  change$;
  size$;
  hovers$;
  camera$;

  constructor(store) {
    this.store = store;

    this.initializeStreams();
    this.initializeManagers();
    this.initializeSystems();

    // dev note: state manager has to
    this.stateManager = new StateManager(this);

    // fire first render
    this.change$.next();
  }

  initializeManagers() {
    this.assetManager = new AssetManager(this);
    this.object3DManager = new Object3DManager(this);
    this.textureManager = new TextureManager(this);
    this.materialManager = new MaterialManager(this);
    this.modelManager = new ModelManager(this);
    this.entityManager = new EntityManager(this);
    this.animationManager = new AnimationManager(this);
  }

  initializeStreams() {
    this.data = createStreams(this.store);

    // main clock
    this.ticker$ = createTicker(() => {
      return true; // pause function for ticker
    });

    // change causes render (with next tick)
    this.change$ = new Subject();
    this.camera$ = new Subject();
    this.hovers$ = new Subject();

    this.size$ = new BehaviorSubject({ width: 800, height: 600 });
  }

  initializeSystems() {
    this.registerSystem(SceneSystem, { background: 0xf5f5f5 });
    this.registerSystem(RenderSystem, {
      showStats: process.env.NODE_ENV === "development",
    });
    this.registerSystem(CameraSystem);
    this.registerSystem(CanvasSystem);
    this.registerSystem(ParentSystem);
    this.registerSystem(MaterialSystem);
    this.registerSystem(MaterialSwitchSystem);
    this.registerSystem(AnimationSystem);
    this.registerSystem(AnimationToggleSystem);
    this.registerSystem(SpriteSystem);
    this.registerSystem(TransformSystem);
    this.registerSystem(InteractionSystem);
    this.registerSystem(VisibilitySystem);
    this.registerSystem(PostProcessingSystem);
  }

  registerSystem(System, props) {
    const unregisterSystem = System(this, props);
    // TODO: each system should return unregister function (used in dispose())
    return unregisterSystem;
  }

  dispose() {
    // TODO: unregisterSystems
  }
}

export default World;
